angular
    .module('vm')
    .component('signUpMay19SmsVerification', {
        templateUrl: 'sign-up-may-19-sms-verification.component.html',
        bindings: {
            'progress': '=',
        },
        controllerAs: 'vm',
        controller: function (CONFIG, SignUpMay19Service, $api, GoogleAnalyticsService, Notifications, $timeout) {
            const vm = this;

            vm.CONFIG = CONFIG;
            vm.formData = {
                phoneNumber: '',
                pinCode: '',
            };

            vm.pin = {
                '0': null,
                '1': null,
                '2': null,
                '3': null,
            };

            vm.wrongCodeError = false;
            vm.phoneNumber = '';

            vm.stepType = 'sms-verification';

            vm.submitForm = submitForm;
            vm.$onInit = activate;
            vm.goBack = goBack;
            vm.onPinClick = onPinClick;

            ////////////

            function activate() {
                const phoneAnswer = SignUpMay19Service.getStepAnswer('phone');

                if (phoneAnswer) {
                    vm.phoneNumber = phoneAnswer.phoneNumber;
                } else {
                    goBack();
                }

                focusOnPin();
            }

            function submitForm(pinCode) {
                vm.formData.phoneNumber = vm.phoneNumber;
                vm.formData.pinCode = pinCode;

                $api.post('phone-verification/check-code', vm.formData)
                    .then(() => {
                        GoogleAnalyticsService.fireEvent(
                            'SignUp May 19', 
                            'sms-verification'
                        );
                        
                        SignUpMay19Service.saveStepAnswer(vm.stepType, vm.formData);
                        SignUpMay19Service.goToNextStep(vm.stepType);
                    })
                    .catch((response) => {
                        vm.wrongCodeError = true;
                        Notifications.add({
                            text: response.data.error,
                            type: 'error'
                        });
                    })
                ;
            }

            function goBack() {
                history.back();
            }

            function onPinClick(inputNum, $event) {
                $event.preventDefault();
            
                if ($event.keyCode >= 48 && $event.keyCode <= 57) {
                  vm.pin[inputNum] = $event.key;
                  vm.wrongCodeError = false;
            
                  if (inputNum < 3) {
                    focusNextInput(inputNum);
                  } else {
                    const pinCode = this.pin['0'] + this.pin['1'] + this.pin['2'] + this.pin['3'];
            
                    blurInputs();
                    submitForm(pinCode);
                  }
                } else if ($event.keyCode === 8) {
                  if (vm.pin[inputNum]) {
                    vm.pin[inputNum] = null;
                  } else {
                    if (inputNum > 0) {
                      focusPrevInput(inputNum);
                    }
                  }
                }
            
                return false;
              }

            function focusInput(input) {
                input.focus();
            }
            
            function focusNextInput(currentInputNum) {
                $timeout(() => {
                    const nextInputNum = currentInputNum + 1;
                    const nextInput = getInputByNum(nextInputNum);
                    focusInput(nextInput);
                });
            }
            
            function focusPrevInput(currentInputNum) {
                $timeout(() => {
                    const prevInputNum = currentInputNum - 1;
                    const prevInput = getInputByNum(prevInputNum);
                    focusInput(prevInput);
                });
            }
            
            function focusOnPin() {
                const el = getInputByNum(0);
            
                if (el) {
                  el.focus();
                }
            }

            function blurInputs() {
                for (let i = 0; i <= 3; i++) {
                    const el = getInputByNum(i);

                    if (el) {
                        el.blur();
                    }
                }
            }

            function getInputByNum(inputNum) {
                return document.querySelector(`.validation-code-${inputNum}`);
            }
        }
    })
;